import { api } from "@/lib/api";

function urlBase64ToUint8Array(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + pad).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

async function ensureSWRegistration() {
  // Register the SW on-demand (works in any environment, including CRA dev).
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  return reg;
}

export async function getPushSubscription() {
  if (!isPushSupported()) return null;
  const reg = await ensureSWRegistration();
  return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Push not supported on this browser");
  // Request notification permission
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission denied");

  const { data } = await api.get("/push/vapid-public-key");
  if (!data?.public_key) throw new Error("Push not configured on server");

  const reg = await ensureSWRegistration();
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getPushSubscription();
  if (sub) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); }
    catch { /* ignore */ }
    await sub.unsubscribe();
  } else {
    try { await api.post("/push/unsubscribe", {}); } catch { /* ignore */ }
  }
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data;
}
